import React, { CSSProperties, FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';

import styles from './index.module.scss';

type PromoListSkeletonProps = {
  dataTestId?: string;
  rowsCount?: number;
  style?: CSSProperties;
};

const PromoListSkeleton: FC<PromoListSkeletonProps> = ({
  dataTestId = DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SKELETON,
  rowsCount = 3,
  style,
}) => (
  <div
    className={styles.skeleton}
    data-testid={dataTestId}
    style={style}
    aria-label={TEXTS.AUDIO_REPORT_PROMOS_LOADING}>
    {Array.from({ length: rowsCount }, (_, index) => (
      <div
        className={styles.row}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SKELETON_ROW(index)}
        key={index}>
        <span className={styles.checkbox} />
        <span className={styles.thumbnail} />
        <span className={styles.content}>
          <span className={styles.title} />
          <span className={styles.campaign} />
        </span>
        <span className={styles.status} />
      </div>
    ))}
  </div>
);

export default memo(PromoListSkeleton);
